<template>
  <div class="selfServe" v-if="Object.keys(selfObj).length > 0">
    <div class="recommend">
      <div class="carousel">
        <div class="carouselImg">
          <img src="../assets/selfServe/zp_bg.gif" alt />
        </div>

        <div class="selfLi">
          <div class="selfContent">
            <div class="selfInfo">
              <p class="selfTitle">{{ selfObj.zp.name }}</p>

              <div class="selfData">
                <p class="selfNum">{{ selfObj.zp.desc.title_1.text }}</p>
                <p class="selfLine">|</p>
                <p class="selfTips">{{ selfObj.zp.desc.title_2.text }}</p>
              </div>
            </div>
          </div>

          <div class="selfButton">
            <div class="buttonMask" v-if="selfObj.zp.status == 5"></div>
            <div
              class="button1"
              @click="zpFunc(selfObj.zp.status, selfObj.zp)"
            >{{ selfObj.zp.button.text }}</div>
            <p class="tips" v-if="selfObj.zp.status == 3" @click="openZpRecord">记录详情></p>
            <p class="tips" v-if="selfObj.zp.desc.title_3">{{ selfObj.zp.desc.title_3.text }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="recommend">
      <div class="carousel">
        <div class="carouselImg">
          <img src="../assets/selfServe/hb_bg.gif" alt />
        </div>

        <div class="selfLi">
          <div class="selfContent">
            <div class="selfInfo">
              <p class="selfTitle">{{ selfObj.hb.name }}</p>

              <div class="selfData">
                <p class="selfNum">{{ selfObj.hb.desc.title_1.text }}</p>
                <p class="selfLine">|</p>
                <p class="selfTips">{{ selfObj.hb.desc.title_2.text }}</p>
              </div>
            </div>
          </div>

          <div class="selfButton">
            <div class="buttonMask" v-if="selfObj.hb.status == 5"></div>
            <div
              class="button2"
              @click="hbFunc(selfObj.hb.status, selfObj.hb)"
            >{{ selfObj.hb.button.text }}</div>

            <p class="tips" v-if="selfObj.hb.status == 3" @click="openHbRecord">记录详情></p>
            <p class="tips" v-if="selfObj.hb.desc.title_3">{{ selfObj.hb.desc.title_3.text }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="hallGet" @click="AllGet"></div>
    <p class="hallTips">昨日投注充值次日来查看活动</p>

    <!-- 开始转盘弹窗 -->
    <div class="turntable_a" v-if="playZpStatus" @click="closePlayZpStatus">
      <div class="turntable" @click.stop>
        <LuckyWheel
          class="turntable_c"
          ref="myLucky"
          id="myCanvas"
          :prizes="prizes"
          :blocks="blocks"
          :buttons="buttons"
          :defaultConfig="defaultConfig"
          @start="startCallback"
          @end="endCallback"
        />

        <img class="play_btn" @click="playGame" src="../assets/selfServe/zp/play_btn.png" alt />

        <p class="playGameNum" @click="playGame">剩余抽奖次数：{{ zpPrizeNum || 0 }}</p>

        <div class="tickArea" @click="tickFunc">
          <img class="tick" v-if="tickStatus" src="../assets/selfServe/zp/tick.png" alt />
        </div>
      </div>
    </div>

    <!-- 转盘获奖弹窗 -->
    <div class="getZp" v-show="getZpStatus">
      <div class="getZpAlert">
        <img src="../assets/selfServe/zpget.png" alt />

        <div class="getZpAlertText">
          <p>
            <span>￥</span>
            {{ zpText }}
          </p>
        </div>

        <div class="closeGetZpArea" @click="closeGetZp"></div>
      </div>
    </div>

    <!-- 转盘失败弹窗 -->
    <div class="loseZp" v-show="loseZpStatus">
      <div class="loseZpAlert">
        <img src="../assets/selfServe/zplose.png" alt />

        <div class="loseZpAlertText">
          <p>{{ zpText }}</p>
        </div>

        <div class="closeloseZpArea" @click="closeZpLose"></div>
      </div>
    </div>

    <!-- 转盘记录弹窗 -->
    <div class="zprecord" v-show="zpRecordStatus">
      <div class="zprecordAlert">
        <img src="../assets/selfServe/zprecord.png" alt />

        <div class="zprecordC" @scroll="handlezpScroll">
          <div class="zprecordScroll">
            <template v-for="(item, index) in zprecordList">
              <div class="recordLi" :key="index">
                <div class="recordTd" style="width:39%">{{ item.created_at }}</div>
                <div class="recordTd" style="width:17%;text-align:center">{{ item.money }}</div>
                <div class="recordTd" style="width:31%;text-align:right">{{ item.status }}</div>
              </div>
            </template>

            <div class="recordLiHeight"></div>
          </div>
        </div>

        <div class="closeRedRecordAlert" @click="closzpRecordAlert"></div>
      </div>
    </div>

    <!-- 开始抢红包弹窗 -->
    <div class="playRedAlert" v-if="playRedStatus" @click="closePlayRedAlert">
      <div class="playRedAlertTips" @click.stop>
        <img src="../assets/selfServe/playRed.png" alt />
        <p class="prizeNum">剩余抢红包次数:{{ prizeNum }}</p>
        <div class="playRedAlertYes" @click="toPlayRed"></div>
      </div>
    </div>

    <!-- 红包获奖弹窗 -->
    <div class="getRed" v-show="getRedStatus">
      <div class="getRedAlert">
        <img src="../assets/selfServe/hbget.png" alt />

        <div class="getRedAlertText">
          <p>
            <span>￥</span>
            {{ redText }}
          </p>
        </div>

        <div class="closeGetRedArea" @click="closeGetRed"></div>
      </div>
    </div>

    <!-- 红包失败弹窗 -->
    <div class="loseRed" v-show="loseRedStatus">
      <div class="loseRedAlert">
        <img src="../assets/selfServe/hblose.png" alt />

        <div class="loseRedAlertText">
          <p>{{ redText }}</p>
        </div>

        <div class="closeloseRedArea" @click="closRedLose"></div>
      </div>
    </div>

    <!-- 红包记录弹窗 -->
    <div class="hbrecord" v-show="hbRecordStatus" @click="closhbRecordAlert">
      <div class="hbrecordAlert" @click.stop>
        <img src="../assets/selfServe/hbrecord.png" alt />

        <div class="hbrecordC" @scroll="handlehbScroll">
          <div class="hbrecordScroll">
            <template v-for="(item, index) in hbrecordList">
              <div class="recordLi" :key="index">
                <div class="recordTd" style="width:33%">{{ item.created_at }}</div>
                <!-- <div class="recordTd" style="width:19%">第{{ item.nth_count || 0 }}次</div> -->
                <div class="recordTd" style="width:36%">获得{{ item.money }}红包</div>
                <div class="recordTd" style="width:20%">{{ item.status }}</div>
              </div>
            </template>

            <div class="recordLiHeight"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 暂无可领取彩金弹窗 -->
    <div class="allNoMoney" v-show="allNoMoneyStatus">
      <div class="allNoMoneyAlert">
        <img src="../assets/selfServe/fail.png" alt />

        <div class="toService" @click="toService"></div>

        <div class="closeallNoMoneyArea" @click="closeAllLose"></div>
      </div>
    </div>

    <!-- 红包雨 -->
    <div class="redRain" v-show="redRainArray.length > 0">
      <div class="redRainLiWidth"></div>
      <template v-for="(item, index) in redRainArray">
        <img
          class="redRainLi"
          :src="item.src"
          :style="{ top: item.top, left: item.left, transition: item.speed }"
          :key="index"
        />
      </template>
    </div>
  </div>
</template>
<script>
import {
  getInfo,
  getPacket,
  getzp,
  gethbinfo,
  getzpinfo,
  getHbHistory,
  getZpHistory
} from "@/api/index";
import { Message } from "element-ui";
import pointerImg from "../assets/selfServe/zp/pointer.png";
import redZpImg from "../assets/selfServe/zp/red.png";
import sectorImg from "../assets/selfServe/zp/sector.png";
import redImg from "../assets/selfServe/red.png";

export default {
  name: "self-Serve",
  props: {
    vipAccount: String,
    serviceUrl: String
  },
  data() {
    return {
      loginStatus: false,
      getRedStatus: false,
      loseRedStatus: false,
      playZpStatus: false,
      getZpStatus: false,
      loseZpStatus: false,
      allNoMoneyStatus: false,
      playRedStatus: false,
      moneyText: "",
      redText: "",
      zpText: "",
      username: "",
      created_at: "",
      recordStatus: "",
      selfObj: {},
      prizeNum: 0,
      zpPrizeNum: 0,
      redRainArray: [],
      debounce: true,
      dealhbStatus: true,
      dealzpStatus: true,
      allGetStatus: false,
      blocks: [{ padding: "0" }],
      prizes: [
        {
          fonts: [
            {
              text: "688",
              top: "10%",
              fontSize: "19px",
              fontColor: "#dd1c1d"
            }
          ],
          imgs: [
            {
              src: sectorImg,
              top: "0",
              width: "87px"
            },
            {
              src: redZpImg,
              top: "50%",
              width: "20px"
            }
          ]
        },
        {
          fonts: [
            {
              text: "18",
              top: "10%",
              fontSize: "19px",
              fontColor: "#dd1c1d"
            }
          ],
          imgs: [
            {
              src: sectorImg,
              top: "0",
              width: "87px"
            },
            {
              src: redZpImg,
              top: "50%",
              width: "20px"
            }
          ]
        },
        {
          fonts: [
            {
              text: "1888",
              top: "10%",
              fontSize: "19px",
              fontColor: "#dd1c1d"
            }
          ],
          imgs: [
            {
              src: sectorImg,
              top: "0",
              width: "87px"
            },
            {
              src: redZpImg,
              top: "50%",
              width: "20px"
            }
          ]
        },
        {
          fonts: [
            {
              text: "8",
              top: "10%",
              fontSize: "19px",
              fontColor: "#dd1c1d"
            }
          ],
          imgs: [
            {
              src: sectorImg,
              top: "0",
              width: "87px"
            },
            {
              src: redZpImg,
              top: "50%",
              width: "20px"
            }
          ]
        },
        {
          fonts: [
            {
              text: "18888",
              top: "10%",
              fontSize: "19px",
              fontColor: "#dd1c1d"
            }
          ],
          imgs: [
            {
              src: sectorImg,
              top: "0",
              width: "87px"
            },
            {
              src: redZpImg,
              top: "50%",
              width: "20px"
            }
          ]
        },
        {
          fonts: [
            {
              text: "188",
              top: "10%",
              fontSize: "19px",
              fontColor: "#dd1c1d"
            }
          ],
          imgs: [
            {
              src: sectorImg,
              top: "0",
              width: "87px"
            },
            {
              src: redZpImg,
              top: "50%",
              width: "20px"
            }
          ]
        },
        {
          fonts: [
            {
              text: "38",
              top: "10%",
              fontSize: "19px",
              fontColor: "#dd1c1d"
            }
          ],
          imgs: [
            {
              src: sectorImg,
              top: "0",
              width: "87px"
            },
            {
              src: redZpImg,
              top: "50%",
              width: "20px"
            }
          ]
        },
        {
          fonts: [
            {
              text: "888",
              top: "10%",
              fontSize: "19px",
              fontColor: "#dd1c1d"
            }
          ],
          imgs: [
            {
              src: sectorImg,
              top: "0",
              width: "87px"
            },
            {
              src: redZpImg,
              top: "50%",
              width: "20px"
            }
          ]
        },

        {
          fonts: [
            {
              text: "88",
              top: "10%",
              fontSize: "19px",
              fontColor: "#dd1c1d"
            }
          ],
          imgs: [
            {
              src: sectorImg,
              top: "0",
              width: "87px"
            },
            {
              src: redZpImg,
              top: "50%",
              width: "20px"
            }
          ]
        }
      ],
      buttons: [
        {
          radius: "45%",
          imgs: [
            {
              src: pointerImg,
              width: "90%",
              top: "-110%"
            }
          ]
        }
      ],
      defaultConfig: {
        gutter: "1px",
        offsetDegree: -17
      },
      tickStatus: false,
      nowJyStatus: 0,
      nowHbStatus: 0,
      nowZpStatus: 0,
      reviewing: false,

      hbRecordStatus: false,
      hbisLoadingMore: false, // 是否正在加载更多
      hbrecordNum: 1, // 当前页码
      hbhasMore: true, // 是否还有更多数据
      hbrecordList: [],

      zpRecordStatus: false,
      zpisLoadingMore: false, // 是否正在加载更多
      zprecordNum: 1, // 当前页码
      zphasMore: true, // 是否还有更多数据
      zprecordList: []
    };
  },
  created() {},
  mounted() {
    this.getSelfData();
  },

  methods: {
    getSelfData() {
      getInfo({
        appid: process.env.VUE_APP_APPID,
        username: this.vipAccount
      }).then(res => {
        if (res.code == 400) {
          Message({
            message: res.msg,
            type: "warning",
            duration: 5 * 1000
          });
          this.$emit("loginFail");
        } else {
          this.selfObj = res.data.activity_info;
          this.nowHbStatus = res.data.activity_info.hb.status;
          this.nowZpStatus = res.data.activity_info.zp.status;

          // 登录成功
          if (res.data.user_info) {
            this.loginStatus = true;
            this.$emit("loginSuccess");

            this.getrealhbinfo();
            this.getrealzpinfo();
          }
        }
      });
    },
    // 红包真实情况
    getrealhbinfo() {
      return new Promise((resolve, reject) => {
        gethbinfo({
          appid: process.env.VUE_APP_APPID,
          username: this.vipAccount,
          show_real_status: true
        })
          .then(res => {
            this.selfObj.hb = res.data;
            this.nowHbStatus = res.data.status;
            this.prizeNum = res.data.desc.title_2.value;
            resolve(res); // 接口成功时调用 resolve
          })
          .catch(error => {
            reject(error); // 接口失败时调用 reject
          });
      });
    },

    // 转盘真实情况
    getrealzpinfo() {
      return new Promise((resolve, reject) => {
        getzpinfo({
          appid: process.env.VUE_APP_APPID,
          username: this.vipAccount,
          show_real_status: true
        })
          .then(res => {
            this.selfObj.zp = res.data;
            this.nowZpStatus = res.data.status;
            this.zpPrizeNum = res.data.desc.title_2.value;
            resolve(res); // 接口成功时调用 resolve
          })
          .catch(error => {
            reject(error); // 接口失败时调用 reject
          });
      });
    },

    // 点击红包按钮
    async hbFunc(status, obj) {
      // 重置一键领取状态
      this.allGetStatus = false;

      if (status === 1) {
        this.$emit("login");
      } else if (status === 2) {
        this.playRedStatus = true;
      } else if (status === 4) {
        window.location.href = obj.button.url;
      }
    },
    // 点击转盘按钮
    async zpFunc(status, obj) {
      // 重置一键领取状态
      this.allGetStatus = false;

      if (status === 1) {
        this.$emit("login");
      } else if (status === 2) {
        this.playZpStatus = true;
      } else if (status === 4) {
        window.location.href = obj.button.url;
      }
    },

    // 点击关闭红包获奖弹窗
    async closeGetRed() {
      this.getRedStatus = false;

      this.getrealhbinfo();

      // 判断是否有红包次数 有就继续抽奖
      if (this.prizeNum > 0) {
        this.playRedStatus = true;
      }
    },

    closRedLose() {
      this.loseRedStatus = false;

      this.getrealhbinfo();
    },

    closeGetZp() {
      this.getZpStatus = false;

      this.getrealzpinfo();

      // 判断是不是一键领取状态 是就继续往下走 不是就判断还有没有次数可以抢 有就继续
      if (this.allGetStatus == true) {
        // 判断是否有红包次数 有就继续抽奖 没有就继续走 打开摇奖弹窗
        if (this.zpPrizeNum > 0) {
          this.playZpStatus = true;
        } else {
          if (this.nowHbStatus == 2) {
            this.prizeNum = this.selfObj.hb.desc.title_2.value;
            this.playRedStatus = true;
          } else if (this.nowHbStatus == 4) {
            this.loseRedStatus = true;
            this.redText = this.selfObj.hb.msg;
            this.selfObj.hb.button.text = "活动详情>";
            this.dealhbStatus = false;
          }
        }
      } else {
        if (this.zpPrizeNum > 0) {
          this.playZpStatus = true;
        }
      }
    },
    closeZpLose() {
      this.loseZpStatus = false;

      this.getrealzpinfo();

      // 一键领取状态
      if (this.allGetStatus == true) {
        if (this.nowHbStatus == 2) {
          this.prizeNum = this.selfObj.hb.desc.title_2.value;
          this.playRedStatus = true;
        } else if (this.nowHbStatus == 4) {
          this.loseRedStatus = true;
          this.redText = this.selfObj.hb.msg;
          this.selfObj.hb.button.text = "活动详情>";
          this.dealhbStatus = false;
        }
      }
    },

    toService() {
      window.location.href = this.serviceUrl;
    },
    closeAllLose() {
      this.allNoMoneyStatus = false;
    },

    // 红包雨动画
    redRainFunc() {
      this.redRainArray = [];
      let owindow_width = document.documentElement.clientWidth;
      window.onresize = () => {
        return (() => {
          owindow_width = document.documentElement.clientWidth;
        })();
      };

      let redWidth = document.querySelector(".redRainLiWidth").offsetWidth;

      clearInterval(this.redTimer);
      this.redTimer = setInterval(() => {
        let red1 = parseInt(Math.random() * (owindow_width - redWidth));
        let red2 = parseInt(Math.random() * redWidth * 2 + 1);
        let speed = parseInt(Math.random() * 3 + 10);

        this.redRainArray.push({
          src: redImg,
          left: red1 + "px",
          top: 0,
          speed: 0
        });

        if (this.redRainArray[this.redRainArray.length - 2]) {
          this.redRainArray[this.redRainArray.length - 2] = {
            src: redImg,
            top: 4000 + "px",
            left: red1 - red2,
            speed: speed + "s all"
          };
        }

        if (this.redRainArray.length > 25) {
          // this.redRainArray = []
          this.redRainArray[this.redRainArray.length - 1] = {
            src: redImg,
            top: 4000 + "px",
            left: red1 - red2,
            speed: speed + "s all"
          };
          clearInterval(this.redTimer);
        }
      }, 200);

      setTimeout(() => {
        this.redRainArray = [];
        clearInterval(this.redTimer);
      }, 4500);
    },

    // 开始抢红包
    toPlayRed() {
      if (this.prizeNum == 0) {
        Message({
          message: "没有抽奖次数！",
          type: "warning",
          duration: 5 * 1000
        });
        return false;
      }

      this.playRedStatus = false;
      this.redRainFunc();

      setTimeout(() => {
        getPacket({
          appid: process.env.VUE_APP_APPID,
          username: this.vipAccount
        }).then(res => {
          this.getRedStatus = true;
          this.redText = res.data.money;
          this.prizeNum = res.data.count;
        });
      }, 3000);
    },
    closePlayRedAlert() {
      this.playRedStatus = false;
    },

    // 开始转盘摇奖
    playGame() {
      if (this.debounce) {
        this.debounce = false;

        // 判断是否跳过旋转
        if (this.tickStatus) {
          getzp({
            appid: process.env.VUE_APP_APPID,
            username: this.vipAccount
          }).then(res => {
            this.zpText = res.data.money;
            this.zpPrizeNum = res.data.count;
            // 直接弹出获奖界面
            this.getZpStatus = true;
            this.debounce = true;
            this.playZpStatus = false;
          });
        } else {
          // 调用抽奖组件的play方法开始游戏
          this.$refs.myLucky.play();
          getzp({
            appid: process.env.VUE_APP_APPID,
            username: this.vipAccount
          }).then(res => {
            this.zpText = res.data.money;
            this.zpPrizeNum = res.data.count;

            this.prizes.forEach((v, i) => {
              if (v.fonts[0].text == res.data.money) {
                // 调用stop停止旋转并传递中奖索引
                this.$refs.myLucky.stop(i);
              }
            });
          });
        }
      }
    },
    closePlayZpStatus() {
      this.playZpStatus = false;
    },
    // 点击抽奖按钮会触发star回调
    startCallback() {},
    // 抽奖结束会触发end回调
    endCallback() {
      this.getZpStatus = true;
      this.debounce = true;
      this.playZpStatus = false;
    },
    // 勾选转盘
    tickFunc() {
      this.tickStatus = !this.tickStatus;
    },

    // 红包记录
    historyhbRecord() {
      if (this.hbisLoadingMore || !this.hbhasMore) return;
      this.hbisLoadingMore = true;

      getHbHistory({
        appid: process.env.VUE_APP_APPID,
        username: this.vipAccount,
        page: this.hbrecordNum
      }).then(res => {
        this.hbrecordList.push(...res.data.datas);
        this.hbrecordNum += 1;
        // 如果新数据长度小于pageSize，则说明没有更多数据
        this.hbhasMore = res.data.datas.length === 10;
        this.hbisLoadingMore = false;
      });
    },
    // 红包记录滚动
    handlehbScroll(event) {
      event.preventDefault();

      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // 当滚动到底部时加载更多
      if (scrollTop + clientHeight >= scrollHeight - 5 && this.hbhasMore) {
        this.historyhbRecord();
      }
    },
    // 打开红包记录详情
    openHbRecord() {
      this.hbRecordStatus = true;

      this.hbrecordNum = 1;
      this.hbrecordList = [];
      this.hbisLoadingMore = false;
      this.hbhasMore = true;
      this.historyhbRecord();
    },
    // 关闭 红包记录
    closhbRecordAlert() {
      this.hbRecordStatus = false;
    },

    // 转盘记录
    historyzpRecord() {
      if (this.zpisLoadingMore || !this.zphasMore) return;
      this.zpisLoadingMore = true;

      getZpHistory({
        appid: process.env.VUE_APP_APPID,
        username: this.vipAccount,
        page: this.zprecordNum
      }).then(res => {
        this.zprecordList.push(...res.data.datas);
        this.zprecordNum += 1;
        // 如果新数据长度小于pageSize，则说明没有更多数据
        this.zphasMore = res.data.datas.length === 10;
        this.zpisLoadingMore = false;
      });
    },
    // 转盘记录滚动
    handlezpScroll(event) {
      event.preventDefault();

      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // 当滚动到底部时加载更多
      if (scrollTop + clientHeight >= scrollHeight - 5 && this.zphasMore) {
        this.historyzpRecord();
      }
    },
    // 打开转盘记录详情
    openZpRecord() {
      this.zpRecordStatus = true;

      this.zprecordNum = 1;
      this.zprecordList = [];
      this.zpisLoadingMore = false;
      this.zphasMore = true;
      this.historyzpRecord();
    },
    // 关闭 转盘记录
    closzpRecordAlert() {
      this.zpRecordStatus = false;
    },

    // 一键领取
    AllGet() {
      this.allGetStatus = true;
      if (!this.loginStatus) {
        this.$emit("login");
      } else {
        let allGet = true;

        // 摇奖 摇奖弹窗
        if (this.nowZpStatus == 2) {
          this.playZpStatus = true;

          allGet = false;
          return false;
        }

        // 红包 红包弹窗
        if (this.nowHbStatus == 2) {
          this.playRedStatus = true;

          allGet = false;
          return false;
        }

        // 判断如果全部情况就不符合 就弹窗暂无彩金
        if (allGet) {
          this.allNoMoneyStatus = true;
        }
      }
    }
  }
};
</script>

<style scoped lang="less">
.selfServe {
  border-radius: 10px;
  overflow: hidden;

  .selfServeHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 43px;
    .selfServeTitle {
      display: flex;
      align-items: center;
      img {
        width: 23px;
      }
      p {
        font-size: 21px;
        margin-left: 5px;
      }
    }
    .selfServeMore {
      font-size: 14px;
      cursor: pointer;
      color: #a7a6a6;
    }
  }
}

.selfLi {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 13px 0;
  border-bottom: 1px solid #ddd;
  .selfContent {
    display: flex;
    align-items: center;
    .selfBg {
      width: 79px;
    }
    .selfInfo {
      margin-left: 10px;
      .selfTitle {
        font-size: 24px;
        font-weight: bold;
      }
      .selfData {
        display: flex;
        align-items: center;
        margin-top: 8px;
      }
      .selfNum {
        color: #7b7b7b;
      }
      .selfLine {
        margin: 0 6px;
      }
      .selfTips {
        color: #ee4a7c;
      }
    }
  }
  .selfButton {
    width: 137px;
    position: relative;
    .button1 {
      background: #882eff;
      width: 106px;
      height: 41px;
      text-align: center;
      line-height: 45px;
      color: #fff;
      font-size: 18px;
      margin: 0 auto;
      border-radius: 23px;
    }
    .button2 {
      background: #ff6660;
      width: 106px;
      height: 41px;
      text-align: center;
      line-height: 45px;
      color: #fff;
      font-size: 18px;
      margin: 0 auto;
      border-radius: 23px;
    }
    .tips {
      color: #ee4a7c;
      text-align: center;
      transform: translate(0, 2px);
    }

    .buttonMask {
      position: absolute;
      width: calc(100% - 31px);
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      top: 0;
      left: 16px;
      border-radius: 18px;
    }
  }
}

.hallGet {
  background: url("../assets/selfServe/hallGet.png") no-repeat;
  background-size: 100% 100%;
  width: 491px;
  height: 69px;
  margin: 15px auto 0;
}
.hallTips {
  color: #ff604c;
  text-align: center;
  margin: 12px 0 36px 0;
  font-size: 17px;
}

.recommend {
  border-radius: 14px;
  margin: 20px;
  box-shadow: 0 0 4px #ad8d9a;
  background: #fff;
  .recommendHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 43px;
    .recommendTitle {
      display: flex;
      align-items: center;
      img {
        width: 23px;
      }
      p {
        font-size: 21px;
        margin-left: 5px;
      }
    }
    .recommendMore {
      font-size: 14px;
      cursor: pointer;
      color: #a7a6a6;
    }
  }
}

.carousel {
  border-radius: 15px;
  overflow: hidden;
  .carouselImg {
    position: relative;
    height: 182px;
    img {
      height: 100%;
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

.initApplyAlert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 6;

  .initApplyAlertTips {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;

    animation: initApplyAlertTipsA 0.5s;

    @keyframes initApplyAlertTipsA {
      from {
        transform: translate(-150%, -50%) scale(0.2);
      }
      to {
        transform: translate(-50%, -50%) scale(1);
      }
    }
    img {
      width: 400px;
    }
    .initApplyAlertYes {
      position: absolute;
      left: 56px;
      bottom: 101px;
      width: 290px;
      height: 67px;
      cursor: pointer;
      border-radius: 12px;
    }
  }
}

.winAlert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 6;
  .winAlertTips {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;

    animation: winAlertTipsA 0.5s;

    @keyframes winAlertTipsA {
      from {
        transform: translate(-150%, -50%) scale(0.2);
      }
      to {
        transform: translate(-50%, -50%) scale(1);
      }
    }

    img {
      width: 400px;
    }
    .winAlertYes {
      position: absolute;
      left: 110px;
      bottom: 37px;
      width: 190px;
      height: 67px;
      cursor: pointer;
      border-radius: 12px;
    }
  }
}
.playRedAlert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 6;
  .playRedAlertTips {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    animation: playRedAlertTipsA 0.5s;

    @keyframes playRedAlertTipsA {
      from {
        transform: translate(-50%, 150%) scale(0.2);
      }
      to {
        transform: translate(-50%, -50%) scale(1);
      }
    }

    img {
      width: 400px;
    }
    .playRedAlertYes {
      position: absolute;
      left: 146px;
      bottom: 104px;
      width: 116px;
      height: 122px;
      cursor: pointer;
      border-radius: 12px;
    }
    .prizeNum {
      color: #7d0300;
      position: absolute;
      left: 50%;
      bottom: 58px;
      font-size: 21px;
      transform: translate(-50%, 0);
    }
  }
}

.getRed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;

  .getRedAlert {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;

    animation: getRedAlertA 0.5s;

    @keyframes getRedAlertA {
      from {
        transform: translate(150%, -50%) scale(0.2);
      }
      to {
        transform: translate(-50%, -50%) scale(1);
      }
    }

    img {
      width: 400px;
    }
    .getRedArea {
      position: absolute;
      left: 217px;
      bottom: 258px;
      width: 374px;
      height: 75px;
      cursor: pointer;
      border-radius: 25px;
    }

    .closeGetRedArea {
      position: absolute;
      left: 47px;
      bottom: 90px;
      width: 299px;
      height: 60px;
      cursor: pointer;
      border-radius: 25px;
    }

    .getRedAlertText {
      position: absolute;
      left: 50%;
      top: 134px;
      transform: translate(-50%, 0);
      height: 78px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 290px;
      font-weight: bold;

      p {
        font-size: 75px;

        font-weight: bold;
        background: linear-gradient(180deg, #fc563e, #fe0103);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;

        span {
          font-size: 28px;
          margin-right: -31px;
        }
      }
    }
  }
}

.loseRed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 6;

  .loseRedAlert {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    animation: loseRedAlertA 0.5s;

    @keyframes loseRedAlertA {
      from {
        transform: translate(-50%, 150%) scale(0.2);
      }
      to {
        transform: translate(-50%, -50%) scale(1);
      }
    }

    img {
      width: 400px;
    }
    .loseRedArea {
      position: absolute;
      left: 217px;
      bottom: 258px;
      width: 374px;
      height: 75px;
      cursor: pointer;
      border-radius: 25px;
    }

    .closeloseRedArea {
      position: absolute;
      left: 34px;
      bottom: 33px;
      width: 331px;
      height: 69px;
      cursor: pointer;
      border-radius: 25px;
    }

    .loseRedAlertText {
      position: absolute;
      left: 50%;
      top: 311px;
      transform: translate(-50%, 0);
      height: 78px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 290px;
      p {
        color: #ff573c;
        font-size: 24px;
        text-align: center;
      }
    }
  }
}

.hbrecord {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 6;

  .hbrecordAlert {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    animation: redrecordAlertA 0.5s;

    @keyframes redrecordAlertA {
      from {
        transform: translate(-50%, 150%) scale(0.2);
      }
      to {
        transform: translate(-50%, -50%) scale(1);
      }
    }

    .hbrecordC {
      width: 467px;
      height: 308px;
      overflow-y: auto;
      position: absolute;
      top: 115px;
      left: 50px;
      overscroll-behavior: contain; /* 阻止滚动传播 */
      .hbrecordScroll {
        width: 100%;
        .recordLi {
          display: flex;
          align-items: center;
          height: 33px;
          .recordTd {
            color: #d1233e;
            font-size: 17px;
            padding-bottom: 6px;
          }
        }
      }

      .recordLiHeight {
        position: fixed;
        top: -10000px;
        left: -10000px;
        height: 65px;
      }
    }

    img {
      width: 500px;
    }
  }
  .closeRedRecordAlert {
    position: absolute;
    left: 230px;
    bottom: 2px;
    width: 42px;
    height: 42px;
    cursor: pointer;
    border-radius: 25px;
  }
}

.zprecord {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 6;

  .zprecordAlert {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    animation: redrecordAlertA 0.5s;

    @keyframes redrecordAlertA {
      from {
        transform: translate(-50%, 150%) scale(0.2);
      }
      to {
        transform: translate(-50%, -50%) scale(1);
      }
    }

    .zprecordC {
      width: 443px;
      height: 242px;
      overflow-y: auto;
      position: absolute;
      top: 528px;
      left: 58px;
      overscroll-behavior: contain;
      .zprecordScroll {
        width: 100%;
        .recordLi {
          display: flex;
          align-items: center;
          height: 26px;
          .recordTd {
            color: #ff0028;
            font-size: 17px;
            padding-bottom: 6px;
          }
        }
      }

      .recordLiHeight {
        position: fixed;
        top: -10000px;
        left: -10000px;
        height: 65px;
      }
    }

    img {
      width: 500px;
    }
  }
  .closeRedRecordAlert {
    position: absolute;
    right: 11px;
    top: 9px;
    width: 48px;
    height: 48px;
    cursor: pointer;
    border-radius: 25px;
  }
}

.zpAlert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 6;
  .zpAlertTips {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    animation: zpAlertTipsA 0.5s;

    @keyframes zpAlertTipsA {
      from {
        transform: translate(-150%, -50%) scale(0.2);
      }
      to {
        transform: translate(-50%, -50%) scale(1);
      }
    }

    img {
      width: 400px;
    }
    .zpAlertYes {
      position: absolute;
      left: 82px;
      bottom: 13px;
      width: 261px;
      height: 51px;
      cursor: pointer;
      border-radius: 12px;
    }
  }
}
.getZp {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 6;

  .getZpAlert {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    animation: getZpAlertA 0.5s;

    @keyframes getZpAlertA {
      from {
        transform: translate(150%, -50%) scale(0.2);
      }
      to {
        transform: translate(-50%, -50%) scale(1);
      }
    }

    img {
      width: 400px;
    }
    .getZpArea {
      position: absolute;
      left: 217px;
      bottom: 258px;
      width: 374px;
      height: 75px;
      cursor: pointer;
      border-radius: 25px;
    }

    .closeGetZpArea {
      position: absolute;
      left: 68px;
      bottom: 34px;
      width: 267px;
      height: 77px;
      cursor: pointer;
      border-radius: 25px;
    }

    .getZpAlertText {
      position: absolute;
      left: 50%;
      top: 165px;
      transform: translate(-50%, 0);
      height: 78px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 290px;
      font-weight: bold;

      p {
        font-size: 78px;
        font-weight: bold;
        color: #ff1168;

        span {
          font-size: 31px;
          margin-right: -27px;
        }
      }
    }
  }
}

.loseZp {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 6;

  .loseZpAlert {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    animation: loseZpAlertA 0.5s;

    @keyframes loseZpAlertA {
      from {
        transform: translate(-50%, 150%) scale(0.2);
      }
      to {
        transform: translate(-50%, -50%) scale(1);
      }
    }

    img {
      width: 400px;
    }
    .loseZpArea {
      position: absolute;
      left: 217px;
      bottom: 258px;
      width: 374px;
      height: 75px;
      cursor: pointer;
      border-radius: 25px;
    }

    .closeloseZpArea {
      position: absolute;
      left: 44px;
      bottom: 33px;
      width: 320px;
      height: 61px;
      cursor: pointer;
      border-radius: 25px;
    }

    .loseZpAlertText {
      position: absolute;
      left: 50%;
      top: 250px;
      transform: translate(-50%, 0);
      height: 78px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 290px;
      p {
        color: #ff573c;
        font-size: 24px;
        text-align: center;
      }
    }
  }
}

.allNoMoney {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 6;

  .allNoMoneyAlert {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    animation: allNoMoneyAlertA 0.5s;

    @keyframes allNoMoneyAlertA {
      from {
        transform: translate(-50%, 150%) scale(0.2);
      }
      to {
        transform: translate(-50%, -50%) scale(1);
      }
    }
    img {
      width: 400px;
    }
    .allNoMoneyArea {
      position: absolute;
      left: 217px;
      bottom: 258px;
      width: 374px;
      height: 75px;
      cursor: pointer;
      border-radius: 25px;
    }
    .toService {
      position: absolute;
      left: 33px;
      bottom: 50px;
      width: 330px;
      height: 70px;
      cursor: pointer;
      border-radius: 25px;
    }
    .closeallNoMoneyArea {
      position: absolute;
      right: 13px;
      top: 10px;
      width: 50px;
      height: 50px;
      cursor: pointer;
      border-radius: 25px;
    }

    .allNoMoneyAlertText {
      position: absolute;
      left: 50%;
      top: 238px;
      transform: translate(-50%, 0);
      height: 78px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 290px;
      p {
        color: #595959;
        font-size: 21px;
        text-align: center;
      }
    }
  }
}

.redRain {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  .redRainLi {
    position: absolute;
    width: 100px;
  }
  .redRainLiWidth {
    position: fixed;
    top: -10000px;
    left: -10000px;
    width: 100px;
  }
}

.turntable_a {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 6;
  transform: scale(1.07);
}

.turntable {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: inline-block;
  width: 420px;
  height: 547px;
  background: url("../assets/selfServe/zp/turntable.png") no-repeat;
  background-size: 100%;
  position: relative;
  z-index: 1;

  animation: turntableA 0.5s;

  @keyframes turntableA {
    from {
      transform: translate(-50%, 150%) scale(0.2);
    }
    to {
      transform: translate(-50%, -50%) scale(1);
    }
  }
}

.turntable_c {
  position: absolute;
  top: 61px;
  left: 69px;
  z-index: 2;
  height: 280px !important;
  width: 280px !important;
}
.turntable_c canvas {
  height: 280px !important;
  width: 280px !important;
}

.turntable_a .pipe {
  width: 56px;
  height: 132px;
  position: absolute;
  bottom: 84px;
  left: 24px;
}

.turntable_a .handle_no {
  width: 33px;
  height: 105px;
  position: absolute;
  bottom: 84px;
  right: 31px;
  z-index: 1;
}
.turntable_a .handle_yes {
  width: 33px;
  height: 33px;
  position: absolute;
  bottom: 84px;
  right: 31px;
  z-index: 1;
}

.turntable_a .play_btn {
  width: 266px;
  height: 108px;
  position: absolute;
  bottom: 43px;
  right: 2px;
  z-index: 1;
  left: 0;
  margin: 0 auto;
  cursor: pointer;
}
.playGameNum {
  height: 57px;
  width: 263px;
  line-height: 57px;
  color: #fff;
  font-size: 15px;
  margin: 0 auto;
  position: absolute;
  bottom: 68px;
  z-index: 4;
  text-align: center;
  left: 50%;
  transform: translate(-50%, 0);
}
.tickArea {
  position: absolute;
  left: 158px;
  bottom: 138px;
  z-index: 8;
  width: 116px;
  height: 26px;
  .tick {
    width: 19px;
    position: absolute;
    right: 10px;
    bottom: 4px;
  }
}
</style>
